import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ButtonToolbar from "components/bootstrap/ButtonToolbar";
import Button from "components/bootstrap/Button";
import Icon from "components/common/Icon";
import Spinner from "components/common/Spinner";
const StyledIcon = styled(Icon)`
  margin-right: 0.2em;
`;
const isWithCancelProps = (props) => props.displayCancel === void 0 || props.displayCancel === true;
const isWithAsyncSubmit = (props) => props.isAsyncSubmit === true;
const FormSubmit = ({ ...props }) => {
  const { t } = useTranslation("common");
  const {
    bsSize,
    className,
    centerCol,
    disabledSubmit = false,
    formId,
    onSubmit,
    submitButtonText,
    submitButtonType = "submit",
    submitIcon
  } = props;
  const submittingAsync = isWithAsyncSubmit(props) && props.isSubmitting;
  return /* @__PURE__ */ React.createElement(ButtonToolbar, { className }, isWithCancelProps(props) && /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "button",
      bsSize,
      onClick: props.onCancel,
      title: t("actions.cancel"),
      "aria-label": t("actions.cancel"),
      disabled: props.disabledCancel || submittingAsync
    },
    t("actions.cancel")
  ), centerCol, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "primary",
      bsSize,
      disabled: disabledSubmit || submittingAsync,
      form: formId,
      title: submitButtonText,
      "aria-label": submitButtonText,
      type: submitButtonType,
      onClick: onSubmit
    },
    submitIcon && !submittingAsync && /* @__PURE__ */ React.createElement(StyledIcon, { name: submitIcon }),
    submittingAsync ? /* @__PURE__ */ React.createElement(Spinner, { text: props.submitLoadingText, delay: 0 }) : submitButtonText
  ));
};
export default FormSubmit;
